import { Image } from '../Image/Image';
import { Subtitle } from '../Subtitle/Subtitle';
import { Title } from '../Title/Title';
import styles from './UpsaleHowItWorks.module.scss'
export const UpsaleHowItWorks = ({content})=>{
  if(!content){
    return;
  }
  const {image,title,subtitle,items,footerIcon,footerTitle,footerSubtitle} = content;
  return (
    <div className={styles.wrapper}>
      {image && <Image className={styles.image} src={image}/>}
      {title && <Title dangerouslySetInnerHTML={{ __html:title }} tag="h2" className={styles.title}/>}
      {subtitle && <Subtitle dangerouslySetInnerHTML={{ __html:subtitle }} className={styles.subtitle}/>}
      {items &&
        <div className={styles.items}>
          {
            items.map((item,index)=>{
              const {title:boxTitle, text}= item;
              return(
              <div className={styles.box} key={index}>
                <div className={styles.icon}>
                <Image src="/assets/Upsale/BS/fact-icon.svg"/>
                </div>
                <div className={styles.boxContent}>
                  <div className={styles.boxTitle}>{boxTitle}</div>
                  <div className={styles.boxText}>{text}</div>
                </div>
              </div>
              )
              
            })
          }
        </div>
      }
      {footerIcon && <Image className={styles.buddy} src={footerIcon}/>}
      {footerTitle && <div className={styles.footerTitle} dangerouslySetInnerHTML={{ __html:footerTitle }} />}
      {footerSubtitle && <div className={styles.footerSubtitle} dangerouslySetInnerHTML={{ __html:footerSubtitle }} />}
    </div>
  )
}
